import { OrgMemberRole, TeamMemberRole } from '@makyoapp/makyo-sdk/models/ACL'
import {
  MemberField as BaseMemberField,
  DbItemField,
  NotificationItemField,
  TeamItemField,
  TransactionField,
  TrashField,
} from '@makyoapp/makyo-common'

/**
 * Maximum rows count for each db table
 */
export const MAX_ROWS_LIMIT = 50000

/**
 * Maximum extended colors for each brankit
 */
export const MAX_EXTENDED_COLORS = 12

/**
 * Maximum file size allowed for app logo upload
 */
export const MAX_APP_LOGO_FILE_SIZE = 31457280 // 30MB

/**
 * This control every default sidebar size
 * and will be replaced with options from localStorage later
 */
export const DEFAULT_SIDEBAR_SIZE = 250

/**
 * base route for all mainRoutes
 * eq: app-domain.com/u/billing
 */
export const USER_ROUTE = '/u'

/**
 * base user project route
 */
export const USER_PROJECT_ROUTE = 'apps'

/**
 * Represents the route for adding a new app.
 */
export const ADD_NEW_APP_ROUTE = 'add-new-app'

/**
 * base user setting route without slash
 * use by general setting page
 * full route will be: app-domain.com/u/settings
 */
export const USER_ACCOUNT_ROUTE = 'my-account'

/**
 * base user setting route without slash
 * use by general setting page
 * full route will be: app-domain.com/u/my-orgs
 */
export const USER_ORG_ROUTE = 'my-orgs'

/**
 * base user billing route without slash
 */
export const USER_BILLING_ROUTE = 'billing'

/**
 * base user team route without slash
 */
export const USER_TEAM_ROUTE = 'my-teams'

/**
 * base user referral route
 */
export const USER_REF_ROUTE = 'my-referral'

/**
 * base user notifications route
 */
export const USER_NOTIFICATION_SETTING_ROUTE = 'nsettings'

/**
 * base user trashes route
 */
export const USER_TRASH_ROUTE = 'trash'

/**
 * base user inbox route
 */
export const USER_NOTIFICATION_ROUTE = 'notifications'

/**
 * base user invitation route
 */
export const USER_INVITATIONS_ROUTE = 'invitations'

/**
 * base user invitation param route
 */
export const INVITATION_ID_PARAM = ':invitationId'

/**
 * project id param key
 */
export const INVITATION_ID_PARAM_KEY = INVITATION_ID_PARAM.replace(':', '')

/**
 * base route for all route related to org
 * eq: app-domain.com/o/billing
 */
export const ORG_ROUTE = '/o'
/**
 * org app route
 */
export const ORG_APP_ROUTE = 'apps'

/**
 * org acl route
 */
export const ORG_ACL_ROUTE = 'acl'

/**
 * org storage route
 */
export const ORG_STORAGE_ROUTE = 'storage'

/**
 * org brand kit route
 */
export const ORG_BRAND_KIT_ROUTE = 'brand-kit'

/**
 * org members route
 */
export const ORG_MEMBER_ROUTE = 'members'

/**
 * org teams route
 */
export const ORG_TEAM_ROUTE = 'teams'

/**
 * org billing route
 */
export const ORG_BILLING_ROUTE = 'billing'

/**
 * org database route
 */
export const ORG_DATABASE_ROUTE = 'db'

/**
 * org billing subscriptions route
 */
export const ORG_BILLING_SUBSCRIPTION_ROUTE = 'subscriptions'

/**
 * org billing subscriptions route
 */
export const ORG_BILLING_SUBSCRIPTION_CANCELLED_ROUTE = 'cancelled'

/**
 * org billing subscriptions route
 */
export const ORG_BILLING_TRANSACTION_ROUTE = 'transactions'

/**
 * base route for table
 */
//export const DB_ROUTE = '/db'

/**
 * base route for all projectRoutes
 * eq: app-domain.com/p/projectIdentity/settings
 */
export const PROJECT_ROUTE = '/p'

/**
 * base route for plugin oauth2 callback
 */
export const PLUGIN_OAUTH2_CALLBACK_ROUTE = '/plugins/oauth2/callback'

/**
 * use in route to determine projectId key
 *
 * :projectId/
 */
export const PROJECT_ID_PARAM = ':projectId'

/**
 * project id param key
 */
export const PROJECT_ID_PARAM_KEY = PROJECT_ID_PARAM.replace(':', '')

/**
 * use in route to determine dbId key
 *
 * :dbId/
 */
export const DB_ID_PARAM = ':dbId'

/**
 * database id param key
 */
export const DB_ID_PARAM_KEY = DB_ID_PARAM.replace(':', '')

/**
 * use in route to determine dbId key
 *
 * :dbId/
 */
export const TBL_ID_PARAM = ':tblId'

/**
 * database id param key
 */
export const TBL_ID_PARAM_KEY = TBL_ID_PARAM.replace(':', '')

/**
 * use in route to determine teamId key
 */
export const ORG_ID_PARAM = ':orgId'

/**
 * the key for useParams
 */
export const ORG_ID_PARAM_KEY = ORG_ID_PARAM.replace(':', '')

/**
 * use in route to determine teamId key
 */
export const TEAM_ID_PARAM = ':teamId'

/**
 * the key for useParams
 */
export const TEAM_ID_PARAM_KEY = TEAM_ID_PARAM.replace(':', '')

/**
 * use in route to determine teamId key
 */
export const BRAND_KIT_ID_PARAM = ':brandId'

/**
 * the key for useParams
 */
export const BRAND_KIT_ID_PARAM_KEY = BRAND_KIT_ID_PARAM.replace(':', '')

/**
 * base project setting route without slash
 */
export const PROJECT_DOMAIN_ROUTE = 'domain'

/**
 * base project setting route without slash
 */
export const PROJECT_SETTING_ROUTE = 'settings'

/**
 * base project plugin route without slash
 */
export const PROJECT_PLUGIN_ROUTE = 'plugins'

/**
 * base project billing plugin route without slash
 */
export const PROJECT_BILLING_ROUTE = 'billing'

export const LOGIN_ROUTE = '/login'
export const REGISTER_ROUTE = '/register'

export const DUMMY_ROUTE = '/plugins'
export const LIGHT_ONLY_ROUTE = [LOGIN_ROUTE, REGISTER_ROUTE]
/**
 * base project edit info plugin route without slash
 */
export const PROJECT_EDIT_INFO_ROUTE = 'edit-info'

export const DEFAULT_DEBOUNCE_MS = 800

export const DEFAULT_ROW_PER_PAGE = 10
export const NOTIFICATIONS_ROWS_PER_PAGE = 10
export const DEFAULT_GRID2_PER_PAGE = 4
export const MAKYO_APP_DOMAIN = 'makyo.app'

export const INVITATION_ACTION_KEY = 'action'
export const INVITATION_DATA_KEY = 'data'

//export const FETCH_IP_URL = 'https://api.country.is'

/**
 * list of all keys used to identify localStorage item
 */
export const STORAGE_KEYS = {
  USER_GEO_INFO: '_USER_GEO_INFO_',
  USER_SESSION: 'USER_SESSION',
  USER_TOKEN: 'USER_TOKEN',
  PROJECT_FILTER: 'PROJECT_FILTER',
  CACHE_TBL: 'CACHE_TBL_',
  COL_SIZE_SUFFIX: '_COLS',
  IMG_MGR_TAB: 'IMG_MAN_TAB',
  FILE_MGR_TAB: 'FILE_MAN_TAB',
  BUILDER_THEME_MODE: 'BUILDER_THEME_MODE',
  IMAGE_CACHE: 'IMAGE_CACHE',
  GRID_MODAL: 'GRID_MODAL',
  HEADER_MENU_GRID_MODAL: 'HEADER_MENU_GRID_MODAL',
  IS_ADD_COLUMN_MODAL_OPEN: 'IS_ADD_COLUMN_MODAL_OPEN',
  MODAL_INSERT: 'MODAL_INSERT',
  GLIDE_COLUMNS: 'GLIDE_COLUMNS',
  SHOW_TABLE_ROW_IDS: 'SHOW_TABLE_ROW_IDS',
  GRID_LAYOUT_OPTIONS: 'GRID_LAYOUT_OPTIONS',
  GRID_PAGINATION: 'GRID_PAGINATION',
  VERSION_FLAGS: 'VERSION_FLAGS',
  BUILDER_ACTIVE_VIEWPORT: 'BUILDER_ACTIVE_VIEWPORT',
  BRANDKIT_ACTIVE_TYPOGRAPHY: 'BRANDKIT_ACTIVE_TYPOGRAPHY',
  BRANDKIT_ACTIVE_SIZE: 'BRANDKIT_ACTIVE_SIZE',
  APP_USER_AUTH: 'APP_USER_AUTH',
  IMAGE_MANAGER: 'IMAGE_MANAGER',
  COMP_PAGINATION: 'COMP_PAGINATION',
  TEMPORARY_VARIABLES: 'TEMPORARY_VARIABLES',
  COMP_ACC_MENU: 'COMP_ACC_MENU',
  APP_GLOBAL_VARIABLES: 'APP_GLOBAL_VARIABLES',
  GRID_SEARCH_CONFIG: 'GRID_SEARCH_CONFIG',
}

export const APP__UPLOAD_PATH = '/Uploads'
export const APP_PDF_UPLOAD_FOLDER_NAME = 'PDFs'
export const APP_PDF_UPLOAD_PATH = '/PDFs'
export const APP_IMAGE_UPLOAD_FOLDER_NAME = 'Image Uploads'
export const APP_IMAGE_UPLOAD_PATH = '/Image Uploads'
export const APP_FILE_UPLOAD_FOLDER_NAME = 'File Uploads'
export const APP_FILE_UPLOAD_PATH = '/File Uploads'

/**
 * all available user role options without `owner` role for org
 */
export const ORG_ROLE_OPTIONS: OrgMemberRole[] = [
  OrgMemberRole.Member,
  OrgMemberRole.Accountant,
  OrgMemberRole.Manager,
  OrgMemberRole.Admin,
]

/**
 * all available user role options for team
 */
export const TEAM_ROLE_OPTIONS: TeamMemberRole[] = [TeamMemberRole.Viewer, TeamMemberRole.Editor, TeamMemberRole.Admin]

export type MemberField = BaseMemberField | 'addedOn'

export const TEAM_ITEM_FIELDS: TeamItemField[] = ['name', 'members', 'apps', 'created']

export const TEAM_MEMBER_FIELDS: MemberField[] = [
  'name',
  'email',
  'teamRole',
  'addedOn',
  'addedBy',
  //'status',
  //'invited',
  //'joined'
]

export const ORG_MEMBER_FIELDS: BaseMemberField[] = ['name', 'email', 'teams', 'orgRole', 'status', 'invited', 'joined']

export const BILLING_TRANSACTION_FIELDS: TransactionField[] = [
  'item',
  'itemType',
  'transactionStatus',
  'billingAddress',
  'paymentMethod',
  'date',
  'amount',
]

export const TRASH_FIELDS: TrashField[] = ['item', 'type', 'trashedDate', 'pruneDate']

export const NOTIFICATION_FIELDS: NotificationItemField[] = ['title', 'content', 'created']

export const DB_FIELDS: DbItemField[] = [
  'name',
  'source',
  'tableCount',
  'recordCount',
  'teams',
  'apps',
  'size',
  'updated',
  'created',
]

export const IMAGE_REGEX = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i

export const STORAGE_DOMAIN = 'gamesmania.io'
export const STORAGE_PATH = 'storage'

export const ACCEPTED_FILE_TYPES = [
  'image/*',
  '.doc',
  '.docx',
  'application/msword',
  '.xls',
  '.xlsx',
  '.csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.pdf',
  '.html',
  '.js',
  '.css',
  '.ppt',
  '.pptx',
  'video/*',
  'audio/*',
]

export const UPLOAD_FILE_LIMIT = 4

/**
 * order of [primary, secondary, tertiary, neutral]
 */
export const PALETTE_COLOR_OPTIONS: {
  name: string
  schemes: string[]
}[] = [
  {
    name: 'Sunny Safari',
    schemes: ['#FFB100', '#FBC252', '#F0ECCF', '#A3BB98'],
  },
  {
    name: 'Blushing Rose',
    schemes: ['#EAC7C7', '#A0C3D2', '#F7F5EB', '#EAE0DA'],
  },
  {
    name: 'Seaside Escape',
    schemes: ['#579BB1', '#E1D7C6', '#ECE8DD', '#F8F4EA'],
  },
  {
    name: 'Autumn Orchard',
    schemes: ['#FFD31D', '#D63447', '#F57B51', '#F6EEDF'],
  },
  {
    name: 'Midnight Garden',
    schemes: ['#42032C', '#D36B00', '#E6D2AA', '#F1EFDC'],
  },
  {
    name: 'Tropical Oasis',
    schemes: ['#1B262C', '#0F4C75', '#00B7C2', '#FDCB9E'],
  },
  {
    name: 'Pastel Paradise',
    schemes: ['#6867AC', '#A267AC', '#CE7BB0', '#FFBCD1'],
  },
  {
    name: 'Modern Gray',
    schemes: ['#00ABB3', '#3C4048', '#B2B2B2', '#EAEAEA'],
  },
  {
    name: 'Unicorn Dreams',
    schemes: ['#78DEC7', '#D62AD0', '#FB7AFC', '#FBC7F7'],
  },
  {
    name: 'Minty Fresh',
    schemes: ['#986D8E', '#87A8A4', '#D9CAB3', '#EFE3D0'],
  },
  {
    name: 'Violet Visions',
    schemes: ['#89B5AF', '#96C7C1', '#DED9C4', '#D0CAB2'],
  },
  {
    name: 'Seaside Stroll',
    schemes: ['#7D1E6A', '#EEB0B0', '#FFE59D', '#BDE6F1'],
  },
  {
    name: 'Blossom Bash',
    schemes: ['#251B37', '#372948', '#FFCACA', '#FFECEF'],
  },
  {
    name: 'Crimson Sunset',
    schemes: ['#393E46', '#6D9886', '#F2E7D5', '#F7F7F7'],
  },
  {
    name: 'Royal Romance',
    schemes: ['#82AAE3', '#91D8E4', '#BFEAF5', '#EAFDFC'],
  },
  {
    name: 'Cherry Blossom',
    schemes: ['#FF597B', '#FF8E9E', '#F9B5D0', '#EEEEEE'],
  },
  {
    name: 'Frosty Forest',
    schemes: ['#C780FA', '#E3ACF9', '#FADA9D', '#FBF1D3'],
  },
  {
    name: 'Serene Springs',
    schemes: ['#B5D5C5', '#B08BBB', '#ECA869', '#F5F5DC'],
  },
  {
    name: 'Tropical Bliss',
    schemes: ['#472183', '#4B56D2', '#82C3EC', '#F1F6F5'],
  },
  {
    name: 'Midnight Magic',
    schemes: ['#1A120B', '#3C2A21', '#D5CEA3', '#E5E5CB'],
  },
  {
    name: 'Sunkissed Sand',
    schemes: ['#3C6255', '#61876E', '#A6BB8D', '#EAE7B1'],
  },
  {
    name: 'Deep Ocean',
    schemes: ['#3F3B6C', '#624F82', '#9F73AB', '#A3C7D6'],
  },
  {
    name: 'Majestic Mountains',
    schemes: ['#7D0633', '#31112C', '#F2A07B', '#FBDCC4'],
  },
  {
    name: 'Vibrant Village',
    schemes: ['#251B37', '#372948', '#FFCACA', '#FFECEF'],
  },
  {
    name: 'Autumn Aspen',
    schemes: ['#42032C', '#D36B00', '#E6D2AA', '#F1EFDC'],
  },
]

export const LOGO_PLACEHOLDER = 'https://placehold.co/200?text=LOGO&font=Raleway'

export const SAMPLE_VIDEO2 = 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_5mb.mp4'

export const SAMPLE_AUDIO = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'

export const SAMPLE_IMAGES = [
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/1.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/2.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/3.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/1.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/10.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/11.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/12.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/13.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/14.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/15.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/2.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/3.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/4.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/5.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/6.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/7.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/8.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/9.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g1.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g11.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g12.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g13.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g14.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g15.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g16.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g17.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g18.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g19.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g2.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g20.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g21.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g22.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g23.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g24.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g25.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g26.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g3.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g4.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g5.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g6.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g7.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/g8.jpg',
]

export const SAMPLE_AVATARS = [
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-black-woman.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-black-woman2.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-black-woman3.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-business-man.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-old-man.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-old-woman.jpg',
  'https://raw.githubusercontent.com/hermantolim/makyo-assets/master/av-white-man.jpg',
]

export const THUMB_SRC = 'https://storage.makyo.me/assets/thumb_src.svg'
export const THUMB_SRC_M = 'https://storage.makyo.me/assets/thumb_src_m.svg'
export const THUMB_SQUARE = 'https://storage.makyo.me/assets/thumb_square.svg'
export const THUMB_SRC_L = 'https://storage.makyo.me/assets/thumb_src_l.svg'
export const THUMB_AVATAR = 'https://storage.makyo.me/assets/thumb_avatar.svg'

export const SHOW_SEARCH_LIMIT = 4

export const SCREEN_TITLE_MIN = 2
export const SCREEN_TITLE_MAX = 13

export const NUM_REGEX = /^[\-]?[0-9]*[.,]?[0-9]*$/
export const SLUG_REGEX = /^[a-z0-9]+(?:(?:-|_)+[a-z0-9]+)*$/

export const TZ_AUTO = {
  value: 'auto',
  label: 'Auto',
}

export const DATE_LOCALE = {
  value: 'locale',
  label: 'Current User Locale',
}

export const NOW = new Date()

export const BRAND_COLOR_OPTIONS = ['primary', 'surface', 'secondary', 'tertiary']

export const SYS_COLOR_OPTIONS = [
  'primary',
  'primary-container',
  'secondary',
  'secondary-container',
  'tertiary',
  'tertiary-container',
  'background',
  'surface',
  'surface-variant',
]

export const DEFAULT_RICH_TEXT_VALUE = `# Rich Text Component Demo ✨

This is a live preview of what you can do with the **Rich Text** component in Makyo. Use it to display formatted content like guides, descriptions, instructions, and more.

---

## 📌 Features Showcase

### Headings

Use \`#\` through \`####\` for section titles:

#### Example:
- \`#\` = Large Title  
- \`##\` = Section Title  
- \`###\` = Subsection  
- \`####\` = Small Header

---

### Lists

**Bullet list:**

- Item one  
- Item two  
- Item three

**Numbered list:**

1. First step  
2. Second step  
3. Third step

---

### Links

You can include links like this:  
[Visit Makyo](https://makyo.app)

---

### Quotes

Use \`>\` for quotes:

> “This is an example of a quote block. Perfect for testimonials or highlights.”

---

### Bold and Italic

**Bold text**  
*Italic text*  
**_Bold and italic together_**

---

### Dividers

Use \`---\` for a horizontal divider like the one above.

---

Use this component to display documentation, tutorials, dynamic content, or anything that needs structure and clarity.`

export const PAPER_SIZE_MAP = {
  A4: {
    width: 595.2765, // 210 mm * 2.83465 = 595.2765 pt
    height: 841.88905, // 297 mm * 2.83465 = 841.88905 pt
    label: 'A4 (210 × 297 mm)',
  },
  A3: {
    width: 841.88905, // 297 mm * 2.83465 = 841.88905 pt
    height: 1190.553, // 420 mm * 2.83465 = 1190.553 pt
    label: 'A3 (297 × 420 mm)',
  },
  A5: {
    width: 419.5282, // 148 mm * 2.83465 = 419.5282 pt
    height: 595.2765, // 210 mm * 2.83465 = 595.2765 pt
    label: 'A5 (148 × 210 mm)',
  },
  Letter: {
    width: 612, // 8.5 in * 72 = 612 pt
    height: 792, // 11 in * 72 = 792 pt
    label: 'Letter (8.5 × 11 in)',
  },
  Legal: {
    width: 612, // 8.5 in * 72 = 612 pt
    height: 1008, // 14 in * 72 = 1008 pt
    label: 'Legal (8.5 × 14 in)',
  },
  Tabloid: {
    width: 792, // 11 in * 72 = 792 pt
    height: 1224, // 17 in * 72 = 1224 pt
    label: 'Tabloid (11 × 17 in)',
  },
}
